import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
    <App />,
  document.getElementById("root")
);
